<template>
    <div class="my-8" v-if="reviews.length">
        <div class="flex items-center mb-4">
            <h3 class="text-dark text-2xl flex-grow">
                <span class="font-bold">Top 3</span>

                <template v-if="product.brand">&nbsp;{{ product.brand.name }}</template>

                {{ product.name }} Reviews
            </h3>

            <app-tooltip content="We are showing the most popular, recent & relevant reviews">
                <font-awesome-icon class="text-grey-200 cursor-pointer"
                                   :icon="['fas', 'circle-info']"
                                   size="lg"></font-awesome-icon>
            </app-tooltip>
        </div>

        <ReviewCard v-for="review of reviews" :review="review"></ReviewCard>
    </div>
</template>

<script>
import ReviewCard from "@/Components/Reviews/ReviewCard";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import AppTooltip from "@/Components/Utilities/AppTooltip";

export default {
    components: {ReviewCard, FontAwesomeIcon, AppTooltip},
    props: {
        product: Object,
    },
    data() {
        return {
            pagedReviews: null
        };
    },
    mounted() {
        this.getReviews();
    },
    computed: {
        reviews() {
            if (!this.pagedReviews) return [];

            return this.pagedReviews.data;
        }
    },
    methods: {
        async getReviews() {
            const response = await axios.get(this.route("products.reviews.popular", this.product));

            this.pagedReviews = response.data;
        }
    }
};
</script>

<style scoped>

</style>
